import { IRootState } from '..';

export const SELECTOR_SUBTITLES_ACTIVE_TRACK = (state: IRootState) => state.Subtitles.activeTrack;
export const SELECTOR_SUBTITLES_SUBTITLES = (state: IRootState) => state.Subtitles.subtitles;
export const SELECTOR_SUBTITLES_SUBTITLE_ENABLED = (state: IRootState) => state.Subtitles.subtitleEnabled;
export const SELECTOR_CURRENT_CUE_TEXT = (state: IRootState) => state.Subtitles.currentCueText;
export const SELECTOR_SUBTITLE_STYLE = (state: IRootState) => state.Subtitles.style;
